/*
 *
 * UseAntivirusSoftware
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import DataRow from 'Components/DataRow'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'

const UseAntivirusSoftware = (props) => (
  <MerchantModal
    title={formattedMessage.modalTitle}
    customAnalyticsDescription={formattedMessage.introText}
    withoutButton
    onClose={() => props.actions.doHidePopup()}
    topBarTitle=' '
  >
    <div className='pciModalContent'>
      <MerchantGenericCard>
        <div className='pciModalContentHeader'>
          <DataRow full label={formattedMessage.protectionLabel} content={formattedMessage.protectionValue} />
          <DataRow full label={formattedMessage.difficultyLabel} content={formattedMessage.difficultyValue} />
        </div>
      </MerchantGenericCard>
      <div className='pciModalContentValidity'>
        <p className='pciModalContentValidityText'>{formattedMessage.validForLabel}</p>
        <div className='pciModalContentValidityBadges'>
          <MerchantTableBadge symbol label={formattedMessage.ecommerceLabel} status='brand' />
          <MerchantTableBadge symbol label={formattedMessage.motoLabel} status='brand' />
          <MerchantTableBadge symbol label={formattedMessage.faceToFaceLabel} status='brand' />
        </div>
      </div>
      <MerchantGenericCard empty>
        <p>
          {formattedMessage.introText}
        </p>
        <div className='pciModalContentSection'>
          <h1 className='pciModalContentSectionTitle'>{formattedMessage.advise1Title}</h1>
          <p>
            {formattedMessage.advise1Text}
          </p>
        </div>
        <div className='pciModalContentSection'>
          <h1 className='pciModalContentSectionTitle'>{formattedMessage.advise2Title}</h1>
          <p>
            {formattedMessage.advise2Text}
          </p>
        </div>
        <div className='pciModalContentSection'>
          <h1 className='pciModalContentSectionTitle'>{formattedMessage.advise3Title}</h1>
          <p>
            {formattedMessage.advise3Text}
          </p>
        </div>
      </MerchantGenericCard>
    </div>
  </MerchantModal>
)

UseAntivirusSoftware.propTypes = {
  actions: PropTypes.object.isRequired
}

export default UseAntivirusSoftware
